import React from 'react';
import { useChatWidgetContext } from '@/widget/services/useChatWidgetContext';

interface Props {
  template: string;
  startConversation: (template: string) => void;
}

function QuestionButton({ template, startConversation }: Props) {
  const { settings } = useChatWidgetContext();
  const { color, textColor } = settings;

  return (
    <div
      key={template}
      onClick={() => startConversation(template)}
    >
      <span style={{ backgroundColor: color, color: textColor }}>{template}</span>
    </div>
  );
}

export default QuestionButton;
